@for (sub of orderData.sub_order; track sub) {
<div class="sub-content">
  <div class="content-item">
    <h4> رقم الطلب</h4>
    <a href="/pages/orders/{{sub.id}}"><p> #{{sub.reference_number}} </p></a>
  </div>
  <div class="content-item">
    <h4>رقم الفاتورة</h4>
    <p> {{sub.cost?.invoice_details?.invoice_id ?? '-'}} </p>
  </div>
  <div class="content-item">
    <h4>رقم السند</h4>
    <p> {{sub.cost?.invoice_details?.receipt_id ?? '-'}} </p>
  </div>
  <div class="content-item">
    <h4>مصدر الفاتورة</h4>
    <p> {{sub.created_by ?? '-'}} </p>
  </div>
  <div class="content-item">
    <h4>تاريخ الإصدار</h4>
    <p> #{{sub.created_at}} </p>
  </div>
  <div class="content-item">
    <h4> سبب الإيراد الإضافي</h4>
    <p> {{sub.reason}}</p>
  </div>
  @if (sub?.reason === 'مساحة إضافية') {
  <div class="content-item">
    <h4> المساحة </h4>
    <p> {{sub.sub_order_value}} <span class="">م<sup>2</sup></span> </p>
  </div>
  }
  <div class="content-item">
    <h4> إجمالي الإيراد الإضافي</h4>
    <p> {{sub?.cost?.final_cost}} <span>ر.س</span> </p>
  </div>
  <div class="content-item">
    <h4> قيمة الضريبة المضافة </h4>
    <p> {{sub?.cost?.tax_cost}} <span>ر.س</span> </p>
  </div>
  <div class="content-item">
    <h4>صافي الإيراد الإضافي</h4>
    <p> {{sub?.cost?.cost_after_discount}} <span>ر.س</span> </p>
  </div>
  <div class="content-item">
    <h4>حصة الفاحص</h4>
    <p> {{sub?.sub_order_inspector_share_amount
      ?sub?.sub_order_inspector_share_amount: '-'}} <span>ر.س</span>
    </p>
  </div>
  <div class="content-item">
    <h4> حالة الدفع</h4>
    <div class="double-action">
      <p> {{sub?.payment_status}}
        @if (sub?.payment_status === 'مستلم') {
        <img src="assets/images/svg/ellipse-green.svg" alt="">
        }
      </p>
      @if (sub?.payment_status === 'مدفوع') {
      <button (click)="deliveredOrder(sub.pk, received)" class="btn btn-green">
        تم الإستلام
      </button>
      }
    </div>
  </div>
  <div class="content-item">
    <h4> تاريخ الدفع</h4>
    <p> {{sub.payment_date}} </p>
  </div>
  <div class="content-item">
    <h4> طريقة الدفع</h4>
    <p> {{sub.payment_option}}{{sub.card_number}} </p>
  </div>
  <div class="content-item">
    <h4> رقم المعاملة</h4>
    <p>{{sub.fort_id}}</p>
  </div>
  @if(sub.notes) {
  <div class="content-item">
    <h4>ملاحظات</h4>
    <p>{{sub.notes}}</p>
  </div>
  }
  @if (!sub.is_order_paid) {
  <div class="basic-data">
    <button class="btn btn-copy" (click)="copyOrderLink(sub.id)">
      <img src="assets/images/svg/copy-report-link.svg" alt="" />
      <span>نسخ رابط الدفع</span>
    </button>
  </div>
  }
</div>
}
